import React from "react";
import { ToggleButtonComponent, ToggleButtonGroupComponent } from "./styles";

type ToggleProps = {
  value: string;
  onChange: (event: React.MouseEvent<HTMLElement>, value: string) => void;
  options: { label: string; value: string; disabled?: boolean }[];
};

export const Toggle: React.FC<ToggleProps> = ({ value, onChange, options }) => {
  return (
    <ToggleButtonGroupComponent value={value} exclusive onChange={onChange}>
      {options.map((opt) => (
        <ToggleButtonComponent
          key={opt.value}
          value={opt.value}
          disabled={opt.disabled}
        >
          {opt.label}
        </ToggleButtonComponent>
      ))}
    </ToggleButtonGroupComponent>
  );
};
